import axios from "@/libs/axios";

export const useNotificacionStore = defineStore("notificacion", () => {
  // State
  const notificacion = ref({});
  const todas = ref([]);
  const leidas = ref([]);
  const sinleer = ref([]);

  // Getters
  const cantidad = computed(() => sinleer.value.length);

  // Actions
  function setNotificacion(data) {
    notificacion.value = data;
  }

  function setNotificaciones({ leidas: l, sinleer: s, todas: t }) {
    todas.value = t;
    sinleer.value = s;
    leidas.value = l;
  }

  function pushLeida(notif) {
    if (notif) {
      const index = sinleer.value.findIndex((noti) => noti.id == notif.id);
      if (index !== -1) sinleer.value.splice(index, 1);
      leidas.value.push(notif);
    }
  }

  function pushSinleer(notif) {
    const index = leidas.value.findIndex((noti) => noti.id == notif.id);
    if (index !== -1) leidas.value.splice(index, 1);
    sinleer.value.push(notif);
  }

  function pushNotificacion(notif) {
    todas.value.push(notif);
  }

  function pushNotificacionSinLeer(notif) {
    sinleer.value.push(notif);
    todas.value.push(notif);
  }

  // Async actions
  async function cargarNotificaciones(user_id) {
    try {
      const respon = await axios.get(`/api/notificaciones/${user_id}`);
      setNotificaciones({
        leidas: respon.data.leidas,
        sinleer: respon.data.sinleer,
        todas: respon.data.notificaciones,
      });
    } catch (e) {
      console.log(e);
    }
  }

  function marcarLeida({ usuario, notificacion }) {
    return axios
      .get(`/api/notificaciones/markread/${notificacion}/usuario/${usuario}`)
      .then(({ data }) => data);
  }

  async function eliminar({ notificacion: notif, usuario }) {
    try {
      const { data } = await axios.delete(
        `/api/notificaciones/${notif}/usuario/${usuario}`
      );
      return data;
    } catch (e) {
      throw e;
    }
  }

  async function marcarNoLeida({ usuario, notificacion }) {
    return await axios.get(
      `/api/notificaciones/marknoread/${notificacion}/usuario/${usuario}`
    );
  }

  async function todoleido(usuario) {
    return await axios.get(`/api/notificaciones/todoleido/usuario/${usuario}`);
  }

  async function marcarSeleccionadosLeidos({ usuario, seleccionados }) {
    return await axios.post(
      `/api/notificaciones/seleccionados/leidos/usuario/${usuario}`,
      { seleccionados }
    );
  }

  async function eliminarSeleccionados({ usuario, seleccionados }) {
    try {
      const { data } = await axios.post(
        `/api/notificaciones/seleccionados/eliminar/usuario/${usuario}`,
        { seleccionados }
      );
      return data;
    } catch (e) {
      throw e;
    }
  }

  return {
    // State
    notificacion,
    todas,
    leidas,
    sinleer,
    // Getters
    cantidad,
    // Mutations/Actions
    setNotificacion,
    setNotificaciones,
    pushLeida,
    pushSinleer,
    pushNotificacion,
    pushNotificacionSinLeer,
    // Async actions
    cargarNotificaciones,
    marcarLeida,
    eliminar,
    marcarNoLeida,
    todoleido,
    marcarSeleccionadosLeidos,
    eliminarSeleccionados,
  };
});

export default useNotificacionStore;
